import { Reveal, Kicker } from "./motion";

export default function TheProblem() {
  return (
    <section
      data-testid="the-problem"
      className="px-6 md:px-12 py-28 md:py-44 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px] grid md:grid-cols-12 gap-10">
        <div className="md:col-span-3">
          <Reveal>
            <Kicker>A note</Kicker>
          </Reveal>
        </div>
        <div className="md:col-span-8 md:col-start-5">
          <Reveal>
            <p className="font-display font-light text-2xl md:text-4xl lg:text-5xl leading-[1.35] text-verlo max-w-3xl text-balance">
              Most hospitality software still feels like 2012. One system for the floor,
              another for the books, a spreadsheet nobody can find. Every service, stitched
              back together by hand.
            </p>
          </Reveal>
          <Reveal>
            <p className="mt-10 text-lg md:text-xl leading-relaxed text-verlo max-w-xl">
              We thought a business that lives by its evenings deserved better. So we built
              one platform that holds all of it, quietly.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
